import { ReactNode } from "react";
import { useAccessibility } from "../../Store/contexts/AccessibilityContext";
import unimedLogo from '../../assets/images/logo-unimed-campinas.svg';
import Footer from "../Footer";
import "./styles.css";
import HeaderLogin from "../HeaderLogin";

interface Props {
  children: ReactNode;
  title?: string | null
  subTitle?: string | null
}

export default function RegisterLayout({ children, title, subTitle }: Props) {

  const { textStyleAccessibility, contrastMode } = useAccessibility();

  return (
    <div className={contrastMode ? 'container-login' : 'container-login img-background-login'}>
      <HeaderLogin />
      <div className='width-100 container-login-painel'>
        <img src={unimedLogo} width={'227px'} height={'85px'} alt="Logo Unimed" className='login-unimed-logo-cadastrar' />
        <div className='width-100 login-container-center'>
          <div style={textStyleAccessibility} className='container-login-cadastrar'>
            {children}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
